export const roomPathOptions = {
    data() {
        return {
            roomPathOptions: [
                {label: '德州', value: '61'},
                {label: '德州-必下场', value: '62'},
                {label: '德州-AOF', value: '63'},
                {label: '奥马哈', value: '91'},
                {label: '奥马哈-必下场', value: '92'},
                {label: '奥马哈-AOF', value: '93'},
                {label: '大菠萝', value: '51'},
                {label: 'MTT', value: '71'},
                {label: 'SNG', value: '81'}
            ]
        }
    }
};

export const rechargeOrderMixin = {
    data() {
        return {
            appTypeOptions: [
                {label: '全部', value: ''},
                {label: 'Android', value: 1},
                {label: 'iOS', value: 2},
                {label: 'Web', value: 3}
            ],
            statusOptions: [
                {label: '全部', value: ''},
                {label: '待支付', value: 0},
                {label: '支付成功', value: 1},
                {label: '支付失败', value: 2},
            ],
        }
    },
    filters: {
        appTypeName(type) {
            // 1：Android
            // 2：iOS
            // 3：Web
            // 4：Wap
            let arr = ['Android', 'iOS', 'Web', 'Wap'];
            return arr[type - 1];
        },
        channelCodeAndPaymentWay(channelCode, paymentWay) {
            let name = '';
            switch (channelCode) {
                case 'Upay':
                    name = 'Upay' + paymentWayName(paymentWay);
                    break;
                case 'Onepay':
                    name = '易付支付' + paymentWayName(paymentWay);
                    break;
                case 'JF':
                    name = '吉富支付' + paymentWayName(paymentWay);
                    break;
                case 'Alipay-China':
                    name = '国内支付宝' + paymentWayName(paymentWay);
                    break;
                case 'Alipay-HK':
                    name = '香港支付宝' + paymentWayName(paymentWay);
                    break;
                case 'Alipay-Singapore':
                    name = '新加坡支付宝' + paymentWayName(paymentWay);
                    break;
                case 'DaTongPay':
                    name = '大通' + paymentWayName(paymentWay);
                    break;
                case 'EffectPay':
                    name = '影响力支付' + paymentWayName(paymentWay);
                    break;
                case 'Fspay':
                    name = '锋尚支付' + paymentWayName(paymentWay);
                    break;
                case 'JTpay':
                    name = '骏付通' + paymentWayName(paymentWay);
                    break;
                case 'Stronger':
                    name = '最强支付' + paymentWayName(paymentWay);
                    break;
                case 'TeKuai':
                    name = '特快付' + paymentWayName(paymentWay);
                    break;
                case 'TianPay':
                    name = '天天pay' + paymentWayName(paymentWay);
                    break;
                case 'TianJi':
                    name = '天机' + paymentWayName(paymentWay);
                    break;
                case 'TongHe':
                    name = '通合' + paymentWayName(paymentWay);
                    break;
                case 'KeCheng':
                    name = '科成支付' + paymentWayName(paymentWay);
                    break;
                case 'HuiDa':
                    name = '汇达支付' + paymentWayName(paymentWay);
                    break;
                case 'XinChen':
                    name = '星辰' + paymentWayName(paymentWay);
                    break;
                default:
                    break;
            }

            function paymentWayName(type) {
                let arr = [' - 支付宝', ' - 内购', ' - 银联快捷支付', ' - 银行卡', ' - 微信'];
                return arr[type - 1];
            }

            return name;
        },
        statusName(type) {
            let arr = ['待支付', '支付成功', '支付失败 '];
            return arr[type];
        },
        callbackStatusName(type) {
            let arr = ['未回调', '回调成功', '回调失败 '];
            return arr[type - 1];
        }
    }
};

/* 手机号国家码 */
export const mobileCountryCodeOptions = {
    data() {
        return {
            mobileCountryCodeOptions: [
                {
                    label: '中国',
                    value: '86'
                },
                {
                    label: '法国',
                    value: '33'
                },
                {
                    label: '印尼',
                    value: '62'
                },
                {
                    label: '越南',
                    value: '84'
                },
                {
                    label: '泰国',
                    value: '66'
                },
                {
                    label: '日本',
                    value: '81'
                },
                {
                    label: '美国',
                    value: '1'
                },
                {
                    label: '印度',
                    value: '91'
                },
                {
                    label: '加拿大',
                    value: '1'
                },
                {
                    label: '英国',
                    value: '44'
                },
                {
                    label: '德国',
                    value: '49'
                },
                {
                    label: '意大利',
                    value: '39'
                },
                {
                    label: '西班牙',
                    value: '34'
                },
                {
                    label: '葡萄牙',
                    value: '351'
                },
                {
                    label: '澳大利亚',
                    value: '61'
                },
                {
                    label: '荷兰',
                    value: '31'
                },
                {
                    label: '新西兰',
                    value: '64'
                },
                {
                    label: '香港',
                    value: '852'
                },
                {
                    label: '澳门',
                    value: '853'
                },
                {
                    label: '菲律宾',
                    value: '63'
                },
                {
                    label: '韩国',
                    value: '82'
                },
                {
                    label: '柬埔寨',
                    value: '855'
                },
                {
                    label: '马来西亚',
                    value: '60'
                },
                {
                    label: '台湾',
                    value: '886'
                },
                {
                    label: '文莱',
                    value: '673'
                },
                {
                    label: '新加坡',
                    value: '65'
                },
                {
                    label: '俄罗斯联邦',
                    value: '007'
                },
                {
                    label: '阿联酋',
                    value: '971'
                }
            ]
        }
    }
};

/* 时间选择器不可选择未来的时间 */
export const disabledInFuture = {
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            }
        }
    }
};

/* 时间选择器不可选择过去的时间 */
export const disabledInThePast = {
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now();
                }
            }
        }
    }
};
